module.exports = __webpack_public_path__ + "d4456c9998e4116c0b588097e0dc10f7.png";